import React from 'react';
import MDInput from 'components/MDInput';

export default function BillzInput(props) {
  var sxInput = (theme) => {
    return { textAlign: 'left', fontSize: '14px', fontFamily: 'Roboto,Helvetica;', fontWeight: '400' };
  };
  if (props.align === 'right')
    sxInput = (theme) => {
      return { textAlign: 'right', fontSize: '14px', fontFamily: 'Roboto,Helvetica;', fontWeight: '400' };
    };
  return (
    <React.Fragment>
      <MDInput
        sx={{
          outline: 'none',
          input: sxInput,
          fontSize: '14px',
          fontFamily: 'Roboto,Helvetica;',
          fontWeight: '400',
        }}
        {...props}
        label={props.label}
        size="small"
      >
        {props.value}
      </MDInput>
    </React.Fragment>
  );
}
